"use client";

import React from "react";
import { Header } from "@/components/navigation/Header";
import { Footer } from "@/components/navigation/Footer";
import "react-awesome-slider/dist/styles.css";
import { UserSession } from "@/utils/types";
import { CircularProgress, Fab } from "@mui/material";
import { useSession } from "next-auth/react";
import { useDrawer } from "@/utils/DrawerProvider";
import { useTranslation } from "react-i18next";
import ChatDrawer from "@/components/drawers/ChatDrawer";
import { PiChatTeardropText } from "react-icons/pi";
import {
  CarsBanner,
  HomeSpecialOrderBanner,
  OrderBanner,
  SourcingBanner,
  SpecialOrderBanner,
} from "@/components/SpecialOrderBanner";
import { Banners } from "@/components/BannerSlider";
import useChatUserID from "@/components/elements/UseChatId";
import { Line } from "@/components/Line";
// import Image from "next/image";

export default function HomePage() {
  const { openDrawer } = useDrawer();
  const session = useSession().data as UserSession;
  const { t } = useTranslation();

  const chatUserID = useChatUserID(session?.id);

  const handleOpenDrawer = () => {
    openDrawer({
      title: t("Chat"),
      content: <ChatDrawer isConflict={0} id={chatUserID} />,
    });
  };

  if (session && !session?.role) {
    return (
      <div className="page grid h100 w100 center">
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className={"home mp20"}>
        <div className="">
          <br className="mobile-only" />
          <br className="mobile-only" />
          <div className="grid gap30 ">
            <div className=" mobile-only">
              <div className="br20 p30 light-blue-bg c1-auto gap30 vcenter">
                <div>
                  <h2 className="">
                    {t("Hi")} {session?.first_name}{" "}
                  </h2>
                  <p className="">{t("welcome_message")} </p>
                </div>
               <img src="/logo.png" alt="" className="h80px w100" />
              </div>
            </div>
            <Banners isMain={false} />
            <Line />
            <div className=" c1 center bg-grey">
              <div className="c2 mc2 gap30 stretch">
                <OrderBanner />
                <HomeSpecialOrderBanner />
                <SourcingBanner />
                <CarsBanner />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />

      {session?.role !== "admin" && session?.role !== "super-admin" && (
        <Fab
          color="primary"
          className="blue-bg"
          style={{ position: "fixed", bottom: "60px", right: "10px" }}
          size="large"
          onClick={handleOpenDrawer}
        >
          <PiChatTeardropText style={{ width: "20px", height: "20px" }} />
        </Fab>
      )}

      <Footer />
    </>
  );
}
